import { CaretDown } from "@phosphor-icons/react";
import { useState } from "react";
import type { FaqItem } from "../pageContent";

function FAQCard({ item, index }: { item: FaqItem; index: number }) {
	const [isOpen, setIsOpen] = useState(index === 0);

	return (
		<article
			className="rounded-[1.4rem] border border-white/[0.08] bg-white/[0.03] overflow-hidden"
			itemScope
			itemProp="mainEntity"
			itemType="https://schema.org/Question"
		>
			<button
				onClick={() => setIsOpen(!isOpen)}
				className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-white/[0.03]"
				aria-expanded={isOpen}
			>
				<div>
					<p className="text-[11px] uppercase tracking-[0.18em] text-white/35">Question</p>
					<h3
						className="pr-4 pt-3 text-base font-semibold tracking-tight text-white/90"
						itemProp="name"
					>
						{item.question}
					</h3>
				</div>
				<div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-white/[0.08] bg-white/[0.04] text-brand-300">
					<CaretDown size={18} className={`transition-transform ${isOpen ? "rotate-180" : ""}`} />
				</div>
			</button>
			{isOpen && (
				<div
					className="px-5 pb-5"
					itemScope
					itemProp="acceptedAnswer"
					itemType="https://schema.org/Answer"
				>
					<div className="border-t border-white/[0.08] pt-4">
						<p className="text-sm leading-7 text-white/50" itemProp="text">
							{item.answer}
						</p>
					</div>
				</div>
			)}
		</article>
	);
}

export function FAQ({ items }: { items: FaqItem[] }) {
	return (
		<section id="faq" className="py-24 md:py-32">
			<div className="mx-auto max-w-5xl px-6">
				<div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:items-start">
					<div>
						<p className="text-[11px] uppercase tracking-[0.22em] text-brand-300">FAQ</p>
						<h2 className="mt-4 max-w-md text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
							Questions people usually ask before buying
						</h2>
						<p className="mt-5 max-w-[34rem] text-base leading-8 text-white/50 md:text-lg">
							Everything you need to know about Clapio screen recording software.
						</p>
					</div>
					<div className="space-y-3" itemScope itemType="https://schema.org/FAQPage">
						{items.map((item, index) => (
							<FAQCard key={item.question} item={item} index={index} />
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
